import { DragOverlay, useDndContext } from '@dnd-kit/core';
import React, { useMemo } from 'react';
import aptSelectors from 'services/selectors/apt';
import Appointment from '../Appointment';

export function DraggableOverlay() {
  const { active, over } = useDndContext();
  // Stable slices + memoized merge so the lookup below doesn't rebuild on every drag-move render.
  const appointments = aptSelectors.calendar.appointments();
  const blockHours = aptSelectors.calendar.blockHours();
  const data = useMemo(() => [...appointments, ...blockHours], [appointments, blockHours]);
  const activeId = active?.id;
  const item = useMemo(() => {
    const [bookingId] = activeId?.toString()?.split('_') ?? [];
    return data.find(o => o?.id?.toString() === bookingId);
  }, [data, activeId]);

  return (
    <DragOverlay dropAnimation={null}>
      <p style={{ fontWeight: 600, fontSize: 16 }}>{over?.data?.current?.rowId}</p>
      {item ? <Appointment overlay key={item.id} data={item} /> : null}
    </DragOverlay>
  );
}
